module.exports = __webpack_public_path__ + "assets/favicons/apple-touch-icon-114x114.409030af87cbc1f4af6fb78780d8b0ca.png";